module.exports = __webpack_public_path__ + "static/media/checkbox_small_v.72d0e6b6.svg";